/* import $api from '../api'; */
import { $api } from '../api'

import { ICustomer, ILegalData, IUser } from 'dto/users.dto'

export interface IAdminPasswordResult {
  emailSent: boolean
  message: string
}

export default class UsersService {
  //получаем всех пользователей
  static async getAllUsers(): Promise<{ data: IUser[] }> {
    return $api.get('/admins')
  }
  //создание пользователя
  static async createUser(data: IUser): Promise<{ data: IUser }> {
    return $api.post('/admins/new', data)
  }
  //редактирование
  static async editUserById(data: IUser): Promise<{ data: IUser }> {
    return $api.put(`/admins`, data)
  }
  //создание данных юрлица
  static async createLegalData(
    data: ILegalData
  ): Promise<{ data: ILegalData }> {
    return $api.post(`/legal`, data)
  }
  //обновление данных юрлица
  static async editLegalData(data: ILegalData): Promise<{ data: ILegalData }> {
    return $api.put(`/legal`, data)
  }
  //получение всех пользователей (клиентов) с пагинацией
  /**
   * Загружает клиентов с пагинацией.
   * @param pagination — limit и offset
   */
  static async getAllCustomers(
    pagination?: { limit: number; offset: number }
  ): Promise<{ data: ICustomer[]; total: number }> {
    const params = pagination
      ? `?limit=${pagination.limit}&offset=${pagination.offset}`
      : ''
    const response = await $api.get(`/users${params}`)
    const payload = response?.data
    if (Array.isArray(payload)) {
      return { data: payload, total: payload.length }
    }
    return {
      data: Array.isArray(payload?.data) ? payload.data : [],
      total: typeof payload?.total === 'number' ? payload.total : 0,
    }
  }

  /**
   * Загружает клиентов пиццерии с пагинацией.
   * @param id — id пиццерии
   * @param pagination — limit и offset
   */
  static async getUsersByPizzeriaId(
    id: number,
    pagination?: { limit: number; offset: number }
  ): Promise<{ data: ICustomer[]; total: number }> {
    const params = pagination
      ? `?limit=${pagination.limit}&offset=${pagination.offset}`
      : ''
    const response = await $api.get(`/users/pizzeria/${id}${params}`)
    const payload = response?.data
    if (Array.isArray(payload)) {
      return { data: payload, total: payload.length }
    }
    return {
      data: Array.isArray(payload?.data) ? payload.data : [],
      total: typeof payload?.total === 'number' ? payload.total : 0,
    }
  }

  /**
   * Задаёт пароль клиента от имени администратора.
   * @param userId — id клиента
   * @param password — новый пароль
   */
  static async adminSetCustomerPassword(
    userId: number,
    password: string
  ): Promise<IAdminPasswordResult> {
    const response = await $api.put<
      { password: string },
      { data: IAdminPasswordResult }
    >(`/users/${userId}/password`, { password })
    return response?.data
  }

  /**
   * Удаляет пароль клиента от имени администратора.
   * @param userId — id клиента
   */
  static async adminClearCustomerPassword(
    userId: number
  ): Promise<IAdminPasswordResult> {
    const response = await $api.delete(`/users/${userId}/password`)
    return response?.data
  }

  /* 	static async getAllCitiesByValue(data: any): Promise<{data:ICity[]}> {
		return $api.post('/address/cities', data);
	}
	//получение по id
	static async getCityById(id: number): Promise<{data:ICity}> {
		return $api.get(`/address/city/${id}` );
	}
	//создаём город
	static async createCity(data:any): Promise<{data:ICity}> {
		return $api.post('/address/city', data);
	}
	//редактируем категорию
	static async editCityById(data:ICity): Promise<{data:ICity}> {
		return $api.put('/address/city', data);
	}
	//удаляем город
	static async deleteCityById(id: number): Promise<{data:any}> {
		return $api.delete(`/address/city/${id}` );
	} */
}
